<template>
  <div class="roles">
    <!-- <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-button type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>-->

    <el-card>
      <el-row :span="24">
        <el-col :span="12">
          <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus" v-auth="'/role/addList'">新增</el-button>
        </el-col>
      </el-row>
      <el-table ref="multipleTable" :data="page.rows" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="selectionChange">
        <el-table-column show-overflow-tooltip prop="sort" width="50" label="排序" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="name" label="角色名称" width="200" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="resourceDescription" label="角色权限" width="300" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop="userNum" label="关联人数" width="100" align="center">
          <template slot-scope="scope">
            <div class="mainColor" @click="clickRow = scope.row, relateVisible = true">{{ scope.row.userNum }}</div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column show-overflow-tooltip prop label="操作" width="120" align="center">
          <template slot-scope="scope">
            <div class="operationGroup" style="display: flex; justify-content: flex-start">
              <!-- <el-button type="text" @click="getAgentRoleInfo(scope.row.id)">编辑</el-button>-->
              <el-button :disabled="scope.row.userNum != 0" type="text" @click="deleteAgentRoleInfo(scope.row)">删除</el-button>
              <i class="el-icon-edit icon-style" title="编辑" style="width: 50%" @click="getAgentRoleInfo(scope.row.id)"></i>

              <i class="el-icon-delete icon-style" style="width: 50%" v-if="scope.row.agentUserInfoCount == 0" @click="deleteAgentRoleInfo(scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="prev, pager, next, jumper,  total, sizes" style="margin-top: 20px; text-align: left" :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber" @size-change="sizeChange" @current-change="currentChange"></el-pagination>
    </el-card>
    <el-dialog title="关联人员" :visible.sync="relateVisible" width="50%" left>
      <el-card>
        <el-table height="350" ref="multipleTable" :data="clickRow.userList" v-loading="loading" element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 0.8)" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="selectionChange">
          <el-table-column show-overflow-tooltip prop="name" label="人员" minWidth="200" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="clickRow.name" label="职位" minWidth="200" align="center">
            <template>
              <div>{{ clickRow.name }}</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="roleId" label="工号" minWidth="200" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="account" label="手机号" minWidth="200" align="center"></el-table-column>
        </el-table>
      </el-card>
    </el-dialog>
    <el-dialog title="添加角色" :visible.sync="addFormVisible" width="50%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入角色名称" auto-complete="off" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="显示排序" prop="sort">
              <el-input type="number" v-model="addForm.sort" placeholder="请输入显示排序" auto-complete="off" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="角色权限" prop="resource">
              <!-- <el-tree-select
                multiple
                v-model="addForm.resources"
                :styles="styles"
                :selectParams="selectParams"
                :treeParams="treeParams"
                ref="treeSelect"
              />-->
              <el-cascader clearable collapse-tags v-model="addForm.ids" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择资源" :options="subjectTreeList"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="3" v-model="addForm.remark" placeholder="请输入备注" auto-complete="off" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgentRoleInfo">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑角色" :visible.sync="editFormVisible" width="50%" left>
      <el-form ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :span="24">
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="editForm.name" placeholder="请输入角色名称" auto-complete="off" maxlength="255" :disabled="editForm.systemDefault == 1 ? true : false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="12">
            <el-form-item label="显示排序" prop="sort">
              <el-input type="number" v-model="editForm.sort" placeholder="请输入显示排序" auto-complete="off" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="角色权限" prop="resource">
              <!-- <el-tree-select
                v-model="editForm.resources"
                :styles="styles"
                :selectParams="selectParams"
                :treeParams="treeParams"
                ref="treeSelect"
              />-->
              <el-cascader clearable collapse-tags v-model="editForm.ids" :show-all-levels="false" :props="subjectTreeProps" placeholder="请选择资源" :options="subjectTreeList"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :sm="24" :md="24" :lg="24">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" :rows="3" v-model="editForm.remark" placeholder="请输入备注" auto-complete="off" maxlength="255"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateAgentRoleInfo">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      relateVisible: false,
      clickRow: { userList: [] },
      blockAddAgentRoleInfo: false,
      blockUpdateAgentRoleInfo: false,
      subjectTreeProps: {
        multiple: true,
        value: "id",
        label: "name",
        children: "resources",
      },
      subjectTreeList: [],
      selectParams: {
        clearable: true,
        placeholder: "请选择资源",
      },
      styles: {
        width: "100%",
      },
      treeParams: {
        clickParent: true,
        filterable: false,
        "check-strictly": false,
        "default-expand-all": true,
        "expand-on-click-node": false,
        "check-on-click-node": true,
        data: [],
        props: {
          children: "resources",
          label: "name",
          disabled: "disabled",
          value: "id",
        },
      },
      options: [
        {
          id: "全选",
          name: "全选",
        },
        {
          id: "学员管理",
          name: "学员管理",
        },
        {
          id: "学员分组",
          name: "学员分组",
        },
        {
          id: "商品管理",
          name: "商品管理",
        },
        {
          id: "账户明细",
          name: "账户明细",
        },
        {
          id: "订单信息",
          name: "订单信息",
        },
        {
          id: "员工管理",
          name: "员工管理",
        },
        {
          id: "角色权限",
          name: "角色权限",
        },
        {
          id: "账户充值",
          name: "账户充值",
        },
      ],
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {},
      addForm: {
        resource: [],
        name: "",
        remark: "",
      },
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字",
          },
        ],
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确",
          },
        ],
        mode: [
          {
            required: true,
            message: "请输入模式",
            trigger: "blur",
          },
        ],
        remark: [],
      },
      editForm: {
        resource: [],
      },
      editFormRules: {
        sort: [
          {
            pattern: /^[1-9]\d*$/,
            message: "排序格式不正确",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入题型名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 255,
            message: "题型名称长度在1到255个字",
          },
        ],
        mode: [
          {
            required: true,
            message: "请输入模式",
            trigger: "blur",
          },
        ],
        remark: [],
      },
      importForm: {},
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],

      fileAction: `${process.env.BASE_URL}/questionType/upload`,
      fileList: [],
      loading: false,
    };
  },
  methods: {
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange (val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getAgentRoleInfo (id) {
      this.api.agentRoleInfo
        .getAgentRoleInfo({
          id: id,
        })
        .then((result) => {
          this.editForm = result.data;
          console.log("this.editForm", this.editForm);
          this.editFormVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList () {
      this.loading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      // this.searchForm.agentId = this.loginData.agentId;
      this.api.agentRoleInfo
        .pageList(this.searchForm)
        .then((result) => {
          this.loading = false;
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addAgentRoleInfo () {
      if (this.blockAddAgentRoleInfo) {
        return false;
      }
      this.blockAddAgentRoleInfo = true;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addForm.agentId = this.loginData.agentId;
          this.api.agentRoleInfo
            .addAgentRoleInfo(this.addForm)
            .then((result) => {
              if (result.success) {
                this.blockAddAgentRoleInfo = false;
                this.$message.success(result.message);
                this.addFormVisible = false;
              } else {
                this.blockAddAgentRoleInfo = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    updateAgentRoleInfo () {
      if (this.blockUpdateAgentRoleInfo) {
        return false;
      }
      this.blockUpdateAgentRoleInfo = true;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.agentId = this.loginData.agentId;
          this.api.agentRoleInfo
            .updateAgentRoleInfo(this.editForm)
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                this.blockUpdateAgentRoleInfo = false;
                this.editFormVisible = false;
                this.pageList();
              } else {
                this.blockUpdateAgentRoleInfo = false;
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
    },
    deleteAgentRoleInfo (row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.agentRoleInfo
            .deleteAgentRoleInfo([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize);
                const pagenum =
                  this.page.pageNumber > totalPage ? totalPage : this.page.pageNumber;
                this.page.pageNumber = pagenum < 1 ? 1 : pagenum;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => { });
    },

    reset () {
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },

    getResourceTreeForAgent () {
      this.api.agentRoleInfo
        .getResourceTreeForAgent({})
        .then((result) => {
          this.treeParams.data = result.data[0].resources;
          this.subjectTreeList = result.data[0].resources;
          console.log("this.subjectTreeList", this.subjectTreeList);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    ...mapGetters(["loginData"]),
    reqData () {
      return this.$store.state.user;
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.addForm.ids = [];
        this.pageList();
      } else {
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.editForm.ids = [];
        this.pageList();
      } else {
      }
    },
  },
  mounted () {
    this.pageList();
    this.getResourceTreeForAgent();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/role/index.vue